import { styled } from '@mui/material';

import Button from '../../../../../../components/Button';

export const StopAttendanceButton = styled(Button)(({ theme }) => ({
  textTransform: 'uppercase',
  borderRadius: `0 0 ${theme.spacing(4)} ${theme.spacing(4)}`,
}));
